import React from "react";
import { useNavigate } from "react-router-dom";
import { Upload, FileQuestion, HelpCircle, FileText } from "lucide-react";
import { useLang } from "../../hooks/useLang";

const QuickActions = ({ onUploadClick }) => {
  const navigate = useNavigate();
  const { urlLanguage } = useLang();

  const actions = [
    {
      icon: Upload,
      title: "Upload PDF",
      description: "Share your notes with others",
      color: "bg-primary/10 text-primary border border-primary/20",
      onClick: () => onUploadClick && onUploadClick('material')
    },
    {
      icon: FileQuestion,
      title: "PDF to Quiz",
      description: "Turn any PDF into a quiz",
      color: "bg-secondary/15 text-secondary border border-secondary/20",
      onClick: () => navigate(urlLanguage("/forms"))
    },
    {
      icon: FileText,
      title: "Create CV",
      description: "Build your best portfolio",
      color: "bg-secondary/15 text-secondary border border-secondary/20",
      onClick: () => onUploadClick && onUploadClick('cv')
    }
  ];

  return (
    <div className="mb-6 animate-fade-in">
      <h2 className="section-title mb-3 uppercase tracking-wider">Quick Actions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {actions.map((action, i) => (
          <button
            key={i}
            onClick={action.onClick}
            className="bg-card rounded-2xl border border-border/40 p-5 flex flex-col items-center text-center gap-3 hover:border-primary/40 cursor-pointer transition-all duration-300 w-full hover:shadow-md"
          >
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center transition-transform group-hover:scale-105 ${action.color}`}>
              <action.icon size={22} />
            </div>
            <div>
              <p className="text-sm font-bold text-foreground">{action.title}</p>
              <p className="text-xs text-muted-foreground mt-0.5 leading-tight font-medium">{action.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
